exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/stats/last-transactions/last-transactions/last-transactions.component.scss
// module id = ../../../../../src/app/pages/dashboard/stats/last-transactions/last-transactions/last-transactions.component.scss
// module chunks = main